<template>
  <div style="width:100%;height:100%">
    <div id="vrviewer"></div>
    <VrExam :singleExam="singleExam"/>
  </div>
</template>

<script>
import VrExam from './VrExam.vue'
import axios from 'axios'
import api from '../api.js'
require('vrviewer-sdk/dist/vrviewer-sdk.js')
require('vrviewer-sdk/dist/vrviewer-sdk.css')

export default {

  name: 'VrPlayer',
  mixins: [api],
  components: {
    VrExam
  },
  props: {
    id: {
      type: String,
      required: true,
      default: ''
    }
  },
  data () {
    return {
      singleExam: {}
    }
  },
  mounted () {
    const apiServerUrl = 'https://api.liveabc.com'
    let collectionId = this.id || ''
    axios({
      method: 'get',
      url: `${apiServerUrl}/v1/720vr/buildings/${collectionId}`
    }).then((response) => {
      if (response.status === 200) {
        const panoCollection = response.data
        window.VRViewer.init({
          el: '#vrviewer',
          lang: 'en',
          building: panoCollection,
          setting: {
            autoRotateSetting: {
              active: true,
              revert: false,
              rotateDuration: 200000,
              restartTime: 20000
            },
            gyroSetting: {
              active: false
            },
            krpanoSetting: {
              mwheel: true,
              focus: false
            },
            tripodSetting: {
              image: 'https://livevr720.liveabc.com/img/liveabc-logo.png',
              size: 60
            },
            shareSetting: {
              shareUrl: `https://livevr720.liveabc.com/viewer/${collectionId}`
            },
            hideUISetting: {
              hideCollectionInfo: false,
              hidePanoramaList: false,
              hideFloorplan: false,
              hideFullscreen: false,
              hideLoading: false,
              hideMarkerInfo: false
            }
          }
        })
      }
    }).catch((error) => {
      console.log(error)
    })
    const customPopupSection = document.querySelector('.exam-section')
    const customPopupContentSections = document.querySelectorAll('.exam-content')
    customPopupContentSections.forEach(function (contentSection) {
      contentSection.classList.add('hide')
    })
    let vm = this
    window.VRViewer.onMarkerClick = (marker) => {
      console.log(marker)
      this.action = marker.action
      if (marker.type === 'slot') {
        if (marker.action && marker.action !=='video') {
          vm.getSingleExam(marker.action)
          switch (marker.type) {
            case 'slot':
              let discountCouponSection = document.querySelector('.exam')
              discountCouponSection.classList.remove('hide')
              // let player = document.querySelector('.player')
              // player.play()
              break
            default:
              break
          }
        } else if (marker.action ==='video') {
          window.location = "https://livetaichung.azureedge.net/720/Live1903L11_v1.0.0_2020-09-18/index.html"
        }
        customPopupSection.classList.remove('hide')
        window.VRViewer.togglePanoramasList()
      }
    }
  }
}
</script>

<style lang="scss" >
  .vrsdk-header-intro {
    display: none;
  }
</style>
